function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from "react";
import { PropTypes } from "prop-types";
import { logos } from "../../constants";
import "./pactometro.scss";
export const PactometroCards = ({
  seatData,
  colors
}) => {
  const _useState = useState([]),
        _useState2 = _slicedToArray(_useState, 2),
        selectedsId = _useState2[0],
        setSelectedsId = _useState2[1];

  const onchange = id => {
    let selecteds = _toConsumableArray(selectedsId);

    if (selectedsId.some(select => select === id)) {
      selecteds = selecteds.filter(item => item !== id);
    } else {
      selecteds = [].concat(_toConsumableArray(selecteds), [id]);
    }

    setSelectedsId(selecteds);
  };

  const selectedData = seatData.filter(item => selectedsId.some(select => select === item.id));
  const tot = seatData.reduce((ac, item) => ac + item.value, 0);

  const _selectedData$reduce = selectedData.reduce((ac, current) => ({
    seat: ac.seat + current.value,
    votes: ac.votes + current.votes
  }), {
    seat: 0,
    votes: 0
  }),
        seat = _selectedData$reduce.seat;

  return React.createElement("div", {
    className: "block block__pactometro"
  }, React.createElement("div", {
    className: "blockContent"
  }, React.createElement("div", {
    className: "pactometro__grafic"
  }, React.createElement("div", {
    id: "barra",
    className: "pactos-barra"
  }, React.createElement("div", {
    className: "mayoria-pactometro"
  }, React.createElement("p", null, "55")), selectedData.map(element => React.createElement("div", {
    key: element.name,
    className: "partido",
    title: element.name,
    style: {
      width: "".concat(100 / tot * element.value, "%"),
      backgroundColor: element.color
    }
  }, element.seat)))), React.createElement("div", {
    className: "pactometro_cardsWrapper"
  }, React.createElement("ul", {
    className: "pactometro_cards"
  }, seatData && seatData.map((dat, index) => {
    const checked = selectedsId.some(select => select === dat.id);
    return React.createElement("li", {
      key: dat.id,
      className: "pactometro_card ".concat(checked ? "" : "pactometro_card__disabled", " "),
      role: "presentation",
      onClick: () => onchange(dat.id)
    }, React.createElement("div", {
      className: "pactometro_card_label",
      style: {
        backgroundColor: colors[index]
      }
    }, React.createElement("img", {
      className: "party_logo",
      src: logos[dat.name],
      alt: "Logo de ".concat(dat.name),
      title: dat.name
    })), React.createElement("span", {
      className: "pactometro_card_data"
    }, dat.value));
  })), React.createElement("div", {
    className: "pactometro_total_wrapper"
  }, React.createElement("div", {
    className: "pactometro_total"
  }, React.createElement("span", {
    className: "pactometro_total_label"
  }, "TOTAL ESCA\xD1OS"), React.createElement("span", {
    className: "pactometro_total_value"
  }, seat))))));
};
PactometroCards.propTypes = {
  colors: PropTypes.arrayOf(PropTypes.string).isRequired,
  // eslint-disable-next-line
  seatData: PropTypes.array.isRequired
};
export default PactometroCards;